export const BLACKLISTED_DOMAINS = [
  'mail7.io',
  'gmail.com',
  'live.com',
  'outlook.com',
  'rediff.com',
  'yahoo.com',
  'yahoo.co.in',
  'hotmail.com',
  'icloud.com',
];
